import basketDetailsTemplate from './basket_details.html';
import basketTemplate from '../_templates/steps/basket.html';//TODO is this the correct template?
import basketMiniTemplate from './basket_mini.html';

angular.module('BBPublicBooking').directive('bbBasket', () => {
        return {
            restrict: 'A',
            replace: true,
            scope: true,
            templateUrl(element, attrs) {
                if (_.has(attrs, 'mini')) {
                    return basketMiniTemplate.id;
                } else {
                    return basketTemplate.id;
                }
            },
            controllerAs: 'BasketCtrl',

            controller($scope, $uibModal, $translate, $document, BasketService) {
                $scope.setUsingBasket(true);

                this.empty = () => $scope.$eval('emptyBasket()');

                this.view = () => $scope.$eval('viewBasket()');

                $scope.showBasketDetails = function () {
                    if (($scope.bb.current_page === 'basket') || ($scope.bb.current_page === 'checkout')) {
                        return false;
                    } else {
                        return $uibModal.open({
                            templateUrl: basketDetailsTemplate.id,
                            scope: $scope,
                            controller: BasketInstanceCtrl,
                            resolve: {
                                basket() {
                                    return $scope.bb.basket;
                                }
                            }
                        });
                    }
                };

                const BasketInstanceCtrl = function ($scope, $rootScope, $uibModalInstance, basket) {
                    $scope.basket = basket;

                    return $scope.cancel = () => $uibModalInstance.dismiss('cancel');
                };

                $scope.$watch(() => {
                    let len;
                    $scope.basketItemCount = len = $scope.bb.basket ? $scope.bb.basket.length() : 0;
                    $scope.basketStatus = $translate.instant('PUBLIC_BOOKING.BASKET_DETAILS.BASKET_STATUS', {N: len}, 'messageformat');
                });
            },

            link(scope, element, attrs) {
                // stop the default action of links inside directive. you can pass the $event
                // object in from the view to the function bound to ng-click but this keeps
                // the markup tidier
                return element.bind('click', e => e.preventDefault());
            }
        };
    }
);



// WEBPACK FOOTER //
// ../node_modules/bookingbug-angular/src/public-booking/basket/bb_basket.directive.js